<template>
  <div>
    <v-dialog v-model="ui.display" persistent>
      <v-card v-if="interf.reference != null">
        <v-toolbar dense color="primary" dark align="center">
          <v-row>
            <v-col cols="4" align="left">
              <v-toolbar-title>Template di Upload</v-toolbar-title>
            </v-col>
            <v-col cols="1">
              <v-btn small light @click="exportTemplate">
                <v-icon color="primary">mdi-download</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn small light @click="importTemplate">
                <v-icon color="primary">mdi-upload</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn small light @click="save">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn small light @click="addTemplate">
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" align="right">
              <v-btn
                small
                light
                v-if="ui.tabs == 1 || ui.tabs == 2"
                @click="$refs.raw_data_timeout.open()"
              >
                <v-icon color="orange">mdi-weather-cloudy-clock</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" align="right">
              <v-btn
                small
                light
                v-if="ui.tabs == 1 || ui.tabs == 2"
                @click="getUploadImportPreview"
              >
                <v-icon color="indigo">mdi-test-tube</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" align="right">
              <v-btn
                small
                light
                v-if="ui.tabs == 1 || ui.tabs == 2"
                @click="legend.display = true"
              >
                <v-icon color="primary">mdi-format-list-checkbox</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" align="right">
              <v-btn small light @click="close">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-container>
          <v-tabs v-model="ui.tabs" centered color="primary">
            <v-tab>Template di upload</v-tab>
            <v-tab>Query di import</v-tab>
            <v-tab>Filtri test import</v-tab>
          </v-tabs>
          <v-tabs-items v-model="ui.tabs">
            <div style="overflow-y: auto; max-height: calc(80vh - 100px)">
              <v-tab-item>
                <v-row dense>
                  <v-col cols="6" align="left">
                    <v-checkbox
                      label="Autocompila template"
                      v-model="ui.autofill"
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-data-table
                  :headers="ui.table_headers"
                  :items="interf.clone.upload_templates"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td
                        v-for="(field, i) in schema.default_fields
                          .upload_fields"
                        :key="i"
                      >
                        <DynamicInput
                          v-model="item[field.field]"
                          :items="field.values"
                          :type="field.type"
                          :label="field.name"
                        />
                      </td>
                      <td>
                        <v-select
                          multiple
                          label="Variabili"
                          v-model="item.variables"
                          :items="getItems(interf.variables, item.__search)"
                          item-text="name"
                          item-value="uid"
                          style="max-width: 300px"
                          @change="fillTemplate($event, item)"
                        >
                          <!-- Campo di ricerca -->
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-text-field
                                  placeholder="Search"
                                  prepend-inner-icon="mdi-magnify"
                                  v-model="item.__search"
                                  clearable
                                  outlined
                                  dense
                                />
                              </v-list-item-content>
                            </v-list-item>
                          </template>

                          <!-- Tool pulizia -->
                          <template v-slot:append-outer>
                            <v-btn
                              color="indigo darken-1"
                              icon
                              small
                              @click.stop="
                                item.variables.splice(0, item.variables.length);
                                item.template = null;
                              "
                            >
                              <v-icon>mdi-broom</v-icon>
                            </v-btn>
                          </template>

                          <!-- Alert per campo ricerca non pulito -->
                          <template v-slot:prepend>
                            <v-icon
                              v-if="(item.__search || '').trim() != ''"
                              color="amber"
                              >mdi-alert</v-icon
                            >
                            <v-icon v-else color="transparent">mdi-home</v-icon>
                          </template>
                        </v-select>
                      </td>
                      <td>
                        <v-btn small light @click="removeTemplate(item)">
                          <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <QueryEditor
                  v-model="interf.clone"
                  :template="ui.query_keywords"
                  query_field="import_query"
                  :tooltip_options="legend.tooltip"
                />
              </v-tab-item>
              <v-tab-item>
                <v-container>
                  <v-expansion-panels v-model="ui.filter_panel">
                    <v-expansion-panel
                      v-for="(value, field, i) in ui.filter"
                      :key="field"
                    >
                      <v-expansion-panel-header>
                        <v-row align="center">
                          <v-col cols="1" align="center">
                            <v-btn
                              small
                              light
                              @click.stop="togglePanelVisibility(value, i)"
                            >
                              <v-icon color="indigo">{{
                                value.enabled ? "mdi-filter" : "mdi-filter-off"
                              }}</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="10">
                            <i
                              >Data
                              {{
                                field == "start_date" ? "inizio" : "fine"
                              }}:</i
                            >
                            {{
                              value.enabled
                                ? getDateTimeString(
                                    value.date_value,
                                    value.time_value,
                                    false
                                  )
                                : "N.D."
                            }}
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row justify="center">
                          <v-col cols="4">
                            <v-date-picker
                              :disabled="!value.enabled"
                              color="primary"
                              v-model="value.date_value"
                            />
                          </v-col>
                          <v-col cols="4">
                            <v-time-picker
                              :disabled="!value.enabled"
                              format="24hr"
                              color="primary"
                              v-model="value.time_value"
                            />
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-container>
              </v-tab-item>
            </div>
          </v-tabs-items>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="legend.display" width="700">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Legenda parole chiave</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-data-table
            :headers="legend.headers"
            :items="legend.data"
            disable-pagination
            hide-default-footer
          />
        </v-container>
      </v-card>
    </v-dialog>
    <DialogTestImportQuery ref="test_import_query" />
    <DialogTimeoutDatiGrezzi ref="raw_data_timeout" />
  </div>
</template>
<script>
import DynamicInput from "../.common/DynamicInput.vue";
import QueryEditor from "../../GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
import DialogTestImportQuery from "./DialogTestImportQuery.vue";
import DialogTimeoutDatiGrezzi from "./DialogTimeoutDatiGrezzi.vue";
export default {
  name: "DialogUploadTemplate",
  components: {
    DynamicInput,
    QueryEditor,
    DialogTestImportQuery,
    DialogTimeoutDatiGrezzi,
  },
  props: {
    schema: Object,
    machine_id: [String, Number],
  },
  data() {
    return {
      interf: {
        clone: null,
        reference: null,
        variables: null,
      },
      legend: {
        display: false,
        headers: [
          { text: "Keyword", value: "symbol" },
          { text: "Descrizione", value: "des" },
        ],
        data: [
          {
            symbol: "$dati_grezzi",
            des: "Tabella temporanea in cui sono memorizzati i dati",
          },
          { symbol: "$id_macchina", des: "ID macchinario corrente" },
          { symbol: "$id_interfaccia", des: "ID interfaccia corrente" },
          { symbol: "$connext_default", des: "Tabella connext_default" },
          { symbol: "$connext_extra", des: "Tabella connext_extra" },
        ],
        tooltip: [
          "$dati_grezzi",
          "$id_macchina",
          "$id_interfaccia",
          "$connext_default",
          "$connext_extra",
        ],
      },
      NETWORK: null,
      ui: {
        autofill: true,
        display: false,
        filter: {
          start_date: {
            date_value: null,
            enabled: false,
            time_value: null,
          },
          end_date: {
            date_value: null,
            enabled: false,
            time_value: null,
          },
        },
        filter_panel: null,
        table_headers: null,
        tabs: 0,
        query_keywords: [
          {
            targetProperty: null,
            color: "#660066",
            keyword: "$",
            targetField: null,
            template: {},
          },
        ],
      },
    };
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
  },
  methods: {
    addTemplate() {
      const template = { variables: new Array() };
      const keys = Object.keys(this.schema.default_fields.upload_fields);
      for (let i = 0; i < keys.length; i++) {
        template[keys[i].field] = keys[i].default_value;
      }
      this.interf.clone.upload_templates.push(template);
    },
    exportTemplate() {
      var csv = "";
      var keys = [];
      console.log(this.schema.default_fields.upload_fields);
      console.log(this.interf.clone.upload_templates);
      this.schema.default_fields.upload_fields.forEach((e) => {
        csv += e.field + ";";
        keys.push(e.field);
      });
      csv += "\n";
      this.interf.clone.upload_templates.forEach((e) => {
        keys.forEach((k) => {
          csv += e[k] + ";";
        });
        csv += "\n";
      });
      console.log(csv);
      const temp = document.createElement("a");
      const file = new Blob([csv], { type: "text/plain" });
      temp.href = URL.createObjectURL(file);
      temp.setAttribute("download", "upload_template.csv");
      document.body.appendChild(temp);
      temp.click();
      document.body.removeChild(temp);
    },
    importTemplate() {
      var input = document.createElement("input");
      input.type = "file";

      input.onchange = (e) => {
        var file = e.target.files[0];
        console.log(file);
        var reader = new FileReader();
        reader.readAsText(file, "UTF-8");

        reader.onload = (readerEvent) => {
          const fileText = readerEvent.target.result;
          var lines = fileText.split("\n");
          var keys = lines[0].split(";");
          this.interf.clone.upload_templates = [];
          for (let i = 1; i < lines.length; i++) {
            const e = lines[i];
            const template = { variables: new Array() };
            const vals = e.split(";");
            for (let i = 0; i < keys.length; i++) {
              template[keys[i]] = vals[i];
            }
            this.interf.clone.upload_templates.push(template);
          }
          this.$forceUpdate();
        };
      };

      input.click();
    },
    close() {
      Object.assign(this.ui.filter.start_date, {
        enabled: false,
        date_value: null,
        time_value: null,
      });
      Object.assign(this.ui.filter.end_date, {
        enabled: false,
        date_value: null,
        time_value: null,
      });
      this.ui.filter_panel = null;

      Object.assign(this.ui, { display: false, table_headers: null, tabs: 0 });
      Object.assign(this.interf, {
        reference: null,
        clone: null,
        variables: null,
      });
    },
    getItems(src, filter) {
      if ((filter || "").trim() == "") {
        return src;
      }
      filter = filter.toLowerCase().trim();
      const result = new Array();
      src.forEach((item) => {
        if ((item.name || "").toLowerCase().trim().indexOf(filter) >= 0) {
          result.push(item);
        }
      });
      return result;
    },
    fillTemplate(data, item) {
      if (!this.ui.autofill) {
        return;
      }
      let result = "";
      for (let i = 0; i < data.length; i++) {
        result += `{${data[i]}}`;
      }
      item.template = result;
    },
    open(interf) {
      const variables = new Array();
      for (let i = 0; i < interf.registers.length; i++) {
        for (let j = 0; j < interf.registers[i].variables.length; j++) {
          const variable = interf.registers[i].variables[j];
          variables.push({
            name: `${variable._uid} - ${variable._name}`,
            uid: variable._uid,
          });
        }
      }
      Object.assign(this.interf, {
        reference: interf,
        clone: JSON.parse(JSON.stringify(interf)),
        variables: variables,
      });

      try {
        this.interf.clone.import_query = decodeURIComponent(
          atob(this.interf.clone.import_query)
        );
      } catch {
        this.interf.clone.import_query = null;
      }

      const headers = (this.ui.table_headers = new Array());
      const default_fields = this.schema.default_fields.upload_fields;
      for (let i = 0; i < default_fields.length; i++) {
        const field = default_fields[i];
        headers.push({ text: field.name, value: field.field });
      }
      headers.push({ text: "Variabili", value: "_variables" });
      headers.push({ text: "Elimina", value: "_delete" });

      this.ui.display = true;
    },
    removeTemplate(template) {
      const templates = this.interf.clone.upload_templates;
      const index = templates.indexOf(template);
      templates.splice(index, 1);
    },
    save() {
      try {
        this.interf.reference.upload_templates =
          this.interf.clone.upload_templates;
        this.interf.reference.import_query = btoa(
          encodeURIComponent(this.interf.clone.import_query)
        );
      } finally {
        this.close();
      }
    },
    getUploadImportPreview() {
      const that = this;
      const filter = this.ui.filter;
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "getuploadimportpreview",
          token: localStorage.user_token,
          query: btoa(encodeURIComponent(this.interf.clone.import_query)),
          interface_id: this.interf.clone.interface_id,
          machine_id: this.machine_id,
          start_date: filter.start_date.enabled
            ? this.getDateTimeString(
                filter.start_date.date_value,
                filter.start_date.time_value
              )
            : undefined,
          end_date: filter.end_date.enabled
            ? this.getDateTimeString(
                filter.end_date.date_value,
                filter.end_date.time_value
              )
            : undefined,
        },
        method: "POST",
        on: {
          load: function (response) {
            that.$refs.test_import_query.show(JSON.parse(response));
          },
          error(err) {
            that.$refs.test_import_query.showError(err.target.responseText);
          },
        },
        showdialog: false,
      };
      this.NETWORK.AjaxRequest(request);
    },
    togglePanelVisibility(value, index) {
      value.enabled = !value.enabled;
      if (!value.enabled && index == this.ui.filter_panel) {
        this.ui.filter_panel = null;
      }
    },
    getDateTimeString(date_value, time_value, neutral = true) {
      if ((date_value || "").trim() == "") {
        return undefined;
      }
      if ((time_value || "").trim() == "") {
        return undefined;
      }
      const date_str =
        (date_value == null ? "" : date_value) +
        " " +
        (time_value == null ? "" : time_value);
      const d = new Date(Date.parse(date_str));
      const pad = function (value) {
        return value.toString().padStart(2, "0");
      };
      if (neutral) {
        return `${pad(d.getFullYear())}-${pad(d.getMonth() + 1)}-${pad(
          d.getDate()
        )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      } else {
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${pad(
          d.getFullYear()
        )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      }
    },
  },
};
</script>